import Container from '../Container';
import bannerStyle from './banner.module.css'

const BannerShort = ({heading,description,bgImage}) => {
    return (
        <section className={`${bannerStyle['section-4-banner']} ${bannerStyle['overlay']} ${bannerStyle['bg-styler']} d-flex align-items-center`} style={{backgroundImage:`url(${bgImage})`}}>
            <Container className="py-5">
                <div className='row'>
                    <div className='col-12 col-lg-6'>
                        <div className={`${bannerStyle['content']}`}>
                            <h1>{heading || ''}</h1>
                            <p dangerouslySetInnerHTML={{__html:description}} />
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default BannerShort;